import React, { useState } from "react";
import "./Authoriztion.css";
import Box from "@mui/material/Box";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import Permissions from "./Permissions";
import Roles from "./Roles";

function Authoriztion() {
  const [value, setValue] = useState(0);

  return (
    <>
      <div className="Authoriztion m-4">
        <p className="my-sm-2 fs-5 my-md-0 fw-bold pb-3">Authoriztion</p>
        <div className="Select_Authoriztion">
          <Box>
            <BottomNavigation
              showLabels
              value={value}
              onChange={(event, newValue) => {
                setValue(newValue);
              }}
              className="memberMenuBar_bottom"
            >
              <BottomNavigationAction
                className="BottomNavigationAction"
                label="Permissions"
              />
              <BottomNavigationAction
                className="BottomNavigationAction"
                label="Roles"
              />
            </BottomNavigation>
          </Box>
        </div>
        {value === 0 ? <Permissions /> : <Roles />}
      </div>
    </>
  );
}

export default Authoriztion;
